import { createFileRoute } from "@tanstack/react-router"
import Calculator from "@/app/settings/metric/calculator/page"

export const Route = createFileRoute("/settings/metric/calculator")({
  component: Calculator,
})
